import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import moment from 'moment-timezone';

import Strings from '../../../../Strings';
import bulkUploadActions, { BULK_UPLOAD_GET_UPLOAD_RESULT } from './actions';
import SheetDetails from './SheetDetails';
import Select from '../../../../components/Select';

function FileDetails(props) {
  const { location, match, getUpload, onNavigate } = props;
  const fileId = match?.params?.fileId;
  // The upload is always loaded by its uuid, so the page shows its current status. The upload
  // list passes its row along as navigation state; that row is only a snapshot from when the
  // list was loaded, so it is shown just until the fresh upload arrives.
  const stateUpload = location?.state?.uuid === fileId ? location.state : null;
  const [loadedUpload, setLoadedUpload] = React.useState(null);
  const data = (loadedUpload?.uuid === fileId ? loadedUpload : null) || stateUpload;

  React.useEffect(() => {
    if (!fileId) return;
    getUpload(fileId).then(r => {
      if (r?.type === BULK_UPLOAD_GET_UPLOAD_RESULT) {
        setLoadedUpload(r?.response || null);
      }
    });
  }, [fileId, getUpload]);

  const [selectedSheetId, setSelectedSheetId] = React.useState(null);
  // The selected sheet if it belongs to this upload, else its first sheet (also while loading).
  const activeSheetId = data?.sheets?.some(s => s.sheet_id === selectedSheetId)
    ? selectedSheetId
    : data?.sheets?.[0]?.sheet_id || null;

  // const [sheetDetails, setSheetDetails] = React.useState([]);
  
  // const getSheetsDetail = async () => {
  //   const ids = data?.sheets?.map(s => s.sheet_id);
  //   await Promise.all(ids.map(async id => {
  //     const r = await getSheetDetail(id);
  //     setSheetDetails(prev => [...prev, r?.response]);
  //   }));
  // }
  // React.useEffect(() => {
  //   if (data?.sheets?.length) {
  //     getSheetsDetail();
  //   }
  // }, [data]);

  const sheetSelect = React.useMemo(() => {
    if (data?.sheets?.length > 1) {
      return (
        <Select
          data={data?.sheets?.map(s => ({ value: s.sheet_id, label: s.sheet_name }))}
          value={activeSheetId}
          onChange={e => setSelectedSheetId(e?.value)}
        />
      );
    }
    return null;
  }, [data, activeSheetId]);

  return (
    <>
      <div className="infoHeader">
        <div className="rowDirection">
          <button type="button" className="back" onClick={() => onNavigate('/cap-patients/bulk-upload')} tabIndex={0}>
            {Strings.back}
          </button>
          <div className="feildBox">
            File Name:
            {' '}
            <div className="feildValue">{data?.filename}</div>
          </div>
        </div>
        <div className="rowDirection left">
          {data?.uploaded_at && (
            <>
              <div className="feildBox">
                Uploaded at:
                {' '}
                <div className="feildValue">{moment(data.uploaded_at).format('YYYY-MM-DD HH:mm:ss')}</div>
              </div>
              <div className="pathHr"></div>
            </>
          )}
          {data?.processed_at && (
            <>
              <div className="feildBox">
                Processed At:
                {' '}
                <div className="feildValue">{moment(data.processed_at).format('YYYY-MM-DD HH:mm:ss')}</div>
              </div>
              <div className="pathHr"></div>
            </>
          )}
          <div className="feildBox">
            Status:
            {' '}
            <div className="feildValue">{data?.status}</div>
          </div>
        </div>
      </div>
      {activeSheetId && <SheetDetails sheetId={activeSheetId} sheetSelect={sheetSelect} />}
    </>
  );
}

FileDetails.propTypes = {
  getUpload: PropTypes.func.isRequired,
  onNavigate: PropTypes.func.isRequired,
  location: PropTypes.shape({
    state: PropTypes.object,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      fileId: PropTypes.string,
    }),
  }),
};

// Back always returns to the upload list: the tables on this page mirror paging into the URL, so
// history.back() would often just step back through those entries.
const mapDispatchToProps = {
  getUpload: bulkUploadActions.getUpload,
  onNavigate: path => push(path),
};

export default connect(null, mapDispatchToProps)(FileDetails);